<template>
    <router-view :key="$route.path"/>
</template>

<style lang="scss">
@import 'assets/css/all.css'; //폰트어썸
@import 'bootstrap/dist/css/bootstrap.min.css';
// @import '~bootstrap/dist/css/bootstrap.min.css'; //부트스트랩
// @import '~bootstrap-vue/dist/bootstrap-vue.css'; //부트스트랩
@import 'assets/css/custom-bootstrap.scss';
@import 'assets/css/common.scss';
@import 'assets/css/style.scss';

@import url('https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@300;400;500;600;700&display=swap');
@import url(//fonts.googleapis.com/earlyaccess/notosanskr.css);

#app {
  font-family: 'Red Hat Display','Urbanist','Noto Sans KR', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: auto;
}
.btn-primary{
  background-color: #008080 !important;
  border-color: #008080 !important;
}
.btn-primary:hover{
  background-color: rgb(0,102,102) !important;
  border-color: rgb(0,102,102) !important;
}
</style>
